<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
    <artisio-modal :visible="showCommissionsModal" :title="$t('Commissions')" size="lg" @show="onShow"
                   @hidden="onHidden" @ok.prevent="handleSubmit(onSubmit)" :ok-title="$t('Submit')"
                   :is-loading="loading" scrollable modal-class="mobile-full-screen">
      <commission-tiers :model="model" show-minimum-commission-field/>
      <div class="row">
        <div class="col-md-4">
          <percentage-input-widget :model="model" attribute="insurance_rate"/>
        </div>
        <div class="col-md-4">
          <currency-input-widget :model="model" attribute="lot_handling_charge"/>
        </div>
        <div class="col-md-4">
          <percentage-input-widget :model="model" attribute="rebate_rate"/>
        </div>
      </div>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>

  import {createNamespacedHelpers} from 'vuex';
  import ArtisioModal from "../../../../../core/components/artisio-modal/ArtisioModal";
  import InputWidget from "../../../../../core/components/input-widget/InputWidget";
  import CurrencyInputWidget from "../../../../../core/widgets/CurrencyInputWidget";
  import PercentageInputWidget from "../../../../../core/widgets/PercentageInputWidget";
  import CommissionForm from "../models/CommissionForm.model";
  import CommissionTiers from "@/core/components/commission-tiers/CommissionTiers";
  import Commission from "@/core/components/commission-tiers/Commission.model";

  const {mapState, mapActions} = createNamespacedHelpers('receipts');

  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  export default {
    name: "CommissionsModal",
    components: {CommissionTiers, InputWidget, ArtisioModal, CurrencyInputWidget, PercentageInputWidget},
    data: () => {
      return {
        loading: false,
        model: new CommissionForm()
      }
    },
    computed: {
      ...mapState({
        showCommissionsModal: state => state.view.termsData.showCommissionsModal,
        termDataCommissions: state => state.view.termsData.commissions,
        lot_handling_charge: state => state.view.termsData.lot_handling_charge,
        insurance_rate: state => state.view.termsData.insurance_rate,
        minimum_commission: state => state.view.termsData.minimum_commission,
        rebate_rate: state => state.view.termsData.rebate_rate,
      }),
    },
    methods: {
      ...mapActions(['toggleCommissionsModal', 'saveTermsPartialData']),
      async onSubmit() {
        let success = await this.$confirm(this.$i18n.t('Changing terms will trigger automatic recalculation of all associated invoices and settlements. Would you like to proceed?'));
        if (!success) {
          return
        }
        this.loading = true;
        let tmpData = this.model.toJSON()
        console.log(tmpData);
        let requestData = tmpData.commissions.map(commission => commission.toJSON());
        let response = await this.saveTermsPartialData({
          commissions: requestData,
          minimum_commission: tmpData.minimum_commission,
          insurance_rate: tmpData.insurance_rate,
          lot_handling_charge: tmpData.lot_handling_charge,
          rebate_rate: tmpData.rebate_rate,
        });
        this.loading = false;

        if (response.success) {
          this.toggleCommissionsModal(false);
          this.$toast('success', this.$t('Commissions were successfully saved'));
        } else {
          if (response.body.non_field_errors) {
            this.$errorDialog(response.body.non_field_errors[0]);
          } else if (response.toastError) {
            this.$errorDialog(response.toastError);
          } else {
            for (let index in response.body.commissions) {
              this.model.commissions[index].setMultipleErrors(response.body.commissions[index]);
            }
          }
        }
      },
      onShow() {
        this.model = new CommissionForm({
          lot_handling_charge: this.lot_handling_charge,
          minimum_commission: this.minimum_commission,
          insurance_rate: this.insurance_rate,
          rebate_rate: this.rebate_rate,
          commissions: this.termDataCommissions.map(data => new Commission(data))
        })
      },
      onHidden() {
        this.model = new CommissionForm();
        this.toggleCommissionsModal(false);
      },
    },
    watch: {
      'model.rebate_rate'(newValue) {
        if (newValue && parseFloat(newValue) > 0) {
          this.model.minimum_commission = 0;
          if (this.model.commissions && this.model.commissions.length > 0) {
            this.model.commissions[0].percent = 0;
          }
        }
      },
      'model.minimum_commission'(newValue) {
        if (newValue && parseFloat(newValue) > 0) {
          this.model.rebate_rate = 0;
        }
      },
      'model.commissions': {
        handler(commissions) {
          if (commissions && commissions.length > 0) {
            for (let commission of commissions) {
              if (commission.percent && parseFloat(commission.percent) > 0) {
                this.model.rebate_rate = 0;
                break;
              }
            }
          }
        },
        deep: true
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>

